// from - https://stackoverflow.com/questions/161738/what-is-the-best-regular-expression-to-check-if-a-string-is-a-valid-url
export const validURL = (resource = '') => resource.match(/\b(https?):\/\/[\-A-Za-z0-9+&@#\/%?=~_|!:,.;]*[\-A-Za-z0-9+&@#\/%=~_|]/);
export const validSrc = ({ src }) => validURL(src);


// WEBPACK FOOTER //
// ./src/Services/Misc/validators.js